import React from 'react';
import PropTypes from 'prop-types';
import {
  postSubweb, SUBWEB_KEY,
} from 'services/requests'
import { useMutation, queryCache } from 'react-query'
import { toast } from 'react-toastify';
import { Toast, SubwebForm } from 'containers';


const SubwebCreateForm = ({
  onSubmit, onDiscard,
}) => {
  const [createSubweb, { isLoading }] = useMutation(postSubweb, {
    onSuccess: (data) => {
      queryCache.invalidateQueries(SUBWEB_KEY)
      onSubmit(data.data)
      toast.success(
        <Toast
          type="success"
          title="Subweb criada"
          description="A subweb foi criada com sucesso."
        />
      );
    },
    onError: (err) => {
      if (err.response && err.response.status === 409) {
        toast.error(
          <Toast
            type="error"
            title="Endereço já existe."
            description="Experimente introduzir outro endereço."
          />
        );
      } else {
        toast.error(
          <Toast
            type="error"
            title="Erro a criar subweb"
            description={err.message}
          />
        );
      }
    }
  })

  const handleSubmit = async values => {
    const {
      slug,
      namePt,
      nameEn,
      description,
      active,
      typeId,
      uaOnlineId,
      serviceGuruId,
      serviceRHid,
      analyticsId,
      initials,
      logoPtTop,
      logoPtBottom,
      logoEnTop,
      logoEnBottom
    } = values

    const newSubweb = {
      slug,
      namePt,
      nameEn,
      description,
      active,
      typeId,
      uaOnlineId,
      serviceGuruId,
      serviceRHid,
      analyticsId,
      initials,
      logoPtTop,
      logoPtBottom,
      logoEnTop,
      logoEnBottom
    }

    createSubweb(newSubweb)
  };

  return (
    <SubwebForm
      initialValues={{}}
      onSubmit={handleSubmit}
      onDiscard={onDiscard}
      isLoading={isLoading}
    />
  );
};

SubwebCreateForm.propTypes = {
  onSubmit: PropTypes.func,
  onDiscard: PropTypes.func,
};

SubwebCreateForm.defaultProps = {
  onSubmit: () => null,
  onDiscard: () => null,
};

export default SubwebCreateForm;
